import { request } from "./api";

export const addFarm = async (payload) => {
  return await request.post("farm/addPointFarm", payload);
};
export const assignationRequestApi = async (payload) => {
  return await request.post("assignation/createAssignation", payload);
};

export const addFarmCoord = async (payload) => {
  return await request.post("farm/addFarmCoords", payload);
};

export const getFarms = async (userId) => {
  const response = await request.get("farm/getFarm", { params: { user: userId } });
  if (response.data.success) {
    return response.data.data;
  }
  return [];
};

export const updateFarm = async (payload) => {
  const response = await request.put("farm/updatePointFarm", payload);

  if (response.data.success) {
    return response.data;
  }
  return [];
}
